import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { ReactComponent as FacebookIcon } from '@images/facebook.svg'
import { ReactComponent as XIcon } from '@images/x.svg'
import { ReactComponent as LinkedInIcon } from '@images/linkedin.svg'
import { ReactComponent as YoutubeIcon } from '@images/youtube.svg'
import { ReactComponent as InstagramIcon } from '@images/instagram.svg'

const SocialContainer = styled.a`
  display: flex;
  align-items: center;
  svg {
    border-radius: 50%;
  }
`

const SocialPropTypes = {
  handle: PropTypes.string
}


const X = ({handle = "https://twitter.com/klipfolio"}) => {
  return <SocialContainer href={handle} aria-label={"X link"}>
    <XIcon width={26} height={26} />
  </SocialContainer>
}

X.propTypes = SocialPropTypes

const LinkedIn = ({handle = "https://www.linkedin.com/company/klipfolio"}) => {
  return <SocialContainer href={handle} aria-label={"LinkedIn link"}>
    <LinkedInIcon width={26} height={26} />
  </SocialContainer>
}

LinkedIn.propTypes = SocialPropTypes

const Facebook = ({handle = "https://www.facebook.com/Klipfolio"}) => {
  return <SocialContainer href={handle} aria-label={"Facebook link"}>
    <FacebookIcon width={26} height={26} />
  </SocialContainer>
}

Facebook.propTypes = SocialPropTypes

const Instagram = ({handle = "https://www.instagram.com/klipfolio/"}) => {
  return <SocialContainer href={handle} aria-label={"Instagram link"}>
    <InstagramIcon width={26} height={26} />
  </SocialContainer>
}

Instagram.propTypes = SocialPropTypes

const Youtube = ({handle = "https://www.youtube.com/klipfolio"}) => {
  return <SocialContainer href={handle} aria-label={"Youtube link"}>
    <YoutubeIcon width={26} height={26} />
  </SocialContainer>
}

Youtube.propTypes = SocialPropTypes


export default {
  Facebook,
  X,
  LinkedIn,
  Instagram,
  Youtube
}